import clsx from 'clsx';

import Icon from '1_components/Icon/Icon';
import { useResponseStore } from 'state/responseStore';

import S from './Address.module.scss';

import { fonts } from 'styles/fontsRegistry';

export interface Address {
  className?: string;
}

const Address = ({ className }: Address) => {
  const { response } = useResponseStore();

  const streetName = response?.geodata?.addressComponents.streetName;
  const streetNumber = response?.geodata?.addressComponents.streetNumber;

  return (
    <div className={clsx(S.address, className)}>
      {response?.geodata && streetName && streetNumber && (
        <>
          <Icon variant="Location" className={S.icon} />
          <span className={fonts.caption}>
            {`${streetNumber} ${streetName}`}
          </span>
        </>
      )}
    </div>
  );
};
export default Address;
